import { AdminContext } from '@context/Admin';
import { useContext } from 'react';

export default function useAdminContext() {
  return useContext(AdminContext);
}
